<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Channels
            </v-row>
            <div v-if="channels?.length > 0">
                <!--channels table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col v-for="(item, i) in headers" :key="i" 
                        class="tabCell"
                        :class="item.style">
                        {{ item.title }}
                    </v-col>
                </v-row>
                <!-- channels tab -->
                 <v-row v-for="channel in channels" :key="channel.id" no-gutters>
                    <v-col class="tabCell text-left">{{ trademarks(channel) }}</v-col>
                    <v-col class="tabCell text-center">{{ channel.team?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ channel.name }}</v-col>
                    <v-col class="tabCell text-center">{{ channel.stores }}</v-col>
                    <v-col class="tabCell text-center">{{ getTypeByVal(channel.type) }}</v-col>
                        
                    <v-col class="tabCell text-center">
                        <edit-channel :channel="channel" />
                        <delete-channel :channel="channel" />
                    </v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-8 px-4">
                You haven't channels yet!
            </v-row>
        </div>
    </v-container>
</template>
<script>
import editChannel from '../../../components/admin/channels/editChannel.vue';
import deleteChannel from '../../../components/admin/channels/deleteChannel.vue';
export default {
    data() {
        return {
            headers: [
                { title: 'trademarks', style: 'text-left' },
                { title: 'team', style: 'text-center' },
                { title: 'channel name', style: 'text-center' },
                { title: 'number of stores', style: 'text-center' },
                { title: 'channel type', style: 'text-center' },
                { title: 'action', style: 'text-center' },
            ],
            
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        channels() {
            return this.$store.getters.channels_all;
        } 
    },
    methods: {
        trademarks(channel) {
            const res =  channel.trademarks.map(trad => trad.name)
            return res.join(', ');
        },
        getTypeByVal(val) {
            let res = ''
            switch(val) {
                case 1: res = 'team self operates online store'
                break;
                case 2: res = 'team self operates brick&mortar channel'
                break;
                case 3: res = 'trademark self operates brick&mortar channel'
            }
            return res;
        }

    },
    components: { editChannel, deleteChannel }
}
</script>